import React, { lazy, Suspense } from 'react';
import type { InterruptionChooserProps } from 'js/liswp/interruption_chooser';

const InterruptionChooser = lazy(() => import('js/liswp/interruption_chooser'));

const LazyInterruptionChooser = (props: InterruptionChooserProps) => (
  <Suspense fallback={null}>
    <InterruptionChooser {...props} />
  </Suspense>
);

export default LazyInterruptionChooser;
